import { parse } from "query-string";
import { compose, withProps } from "recompose";
var _a = parse(location.search), code = _a.code, state = _a.state;
export var withAuthorization = function () {
    return compose(withProps(function () { return ({
        code: code,
        state: state,
    }); }));
};
